import Text from "components/Text";

const NASection = () => (
  <Text sx={{ opacity: 0.5 }} variant="text2">
    N/A
  </Text>
);

export default NASection;
